'use client'

import { useState, useEffect } from 'react'
import { endImpersonationAction } from '@/app/(admin)/admin/(dashboard)/users/impersonate-action'

interface ImpersonationBannerProps {
    userEmail: string
    adminEmail: string
    expiresAt: number // unix seconds
}

export function ImpersonationBanner({ userEmail, adminEmail, expiresAt }: ImpersonationBannerProps) {
    const [secondsLeft, setSecondsLeft] = useState(() => Math.max(0, expiresAt - Math.floor(Date.now() / 1000)))
    const [ending, setEnding] = useState(false)

    useEffect(() => {
        const interval = setInterval(() => {
            const remaining = Math.max(0, expiresAt - Math.floor(Date.now() / 1000))
            setSecondsLeft(remaining)
            if (remaining <= 0) {
                clearInterval(interval)
                // Auto-end: close tab or redirect
                endImpersonationAction().catch(() => {
                    window.close()
                })
            }
        }, 1000)
        return () => clearInterval(interval)
    }, [expiresAt])

    const minutes = Math.floor(secondsLeft / 60)
    const seconds = secondsLeft % 60

    const handleEnd = async () => {
        setEnding(true)
        try {
            await endImpersonationAction()
        } catch {
            window.close()
        }
    }

    return (
        <div className="sticky top-0 z-[9999] bg-amber-500 text-white px-4 py-2 text-sm font-medium flex items-center justify-center gap-4 shadow-md">
            <span>
                Имперсонализация: вы вошли как <strong>{userEmail}</strong>
                {' '}(админ: {adminEmail})
            </span>
            <span className="tabular-nums">
                {minutes}:{seconds.toString().padStart(2, '0')}
            </span>
            <button
                onClick={handleEnd}
                disabled={ending}
                className="bg-white text-amber-700 px-3 py-1 rounded text-xs font-semibold hover:bg-amber-50 transition-colors disabled:opacity-50"
            >
                {ending ? 'Завершение...' : 'Завершить'}
            </button>
        </div>
    )
}
